

const PillButton = ({ link, text }) => {
  return <a className="w-full shrink-0 my-0.5 text-nowrap lg:text-wrap overflow-hidden lg:max-w-[33%] font-medium rounded-full border lg:border-2 px-2 lg:px-3 text-center border-slate-300 hover:border-blue-700 hover:bg-blue-700 hover:text-white flex items-center h-5 lg:h-auto" href={link}><p>{text.toUpperCase()}</p></a>
}

export default PillButton;
